import React from "react"
import pluralize from "pluralize"
import { departmentMembershipFacilityDepartmentShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"

// The list of the departments on the User show page is now read-only.

const DepartmentMembershipFacilityDepartment = ({ departmentMembershipFacilityDepartment }) => {
  const { name, memberships } = departmentMembershipFacilityDepartment

  const userSegments = Object.keys(memberships).map((segment) => segment.toUpperCase()).sort()
  const userSegmentsText = `${pluralize("Segment", userSegments.length)} ${userSegments.join(", ")}`

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <div className="flex gap-4 w-full">
          <span className="grow">{name}</span>
          <span>{userSegmentsText}</span>
        </div>
      )}
    />
  )
}

DepartmentMembershipFacilityDepartment.propTypes = {
  departmentMembershipFacilityDepartment: departmentMembershipFacilityDepartmentShape.isRequired,
}

export default DepartmentMembershipFacilityDepartment
